/* Do not edit these strings. They are generated by ptmessages.js.php */
ptMessages = {
    "partnerdownloadbookmark": "Haben Sie schon ein Lesezeichen f\u00fcr diese Seite angelegt? Dr\u00fccken Sie strg+d, um ein Lesezeichen anzulegen.",
    "applyunload": "Sie haben die vollst\u00e4ndige Test-Anfrage noch nicht abgesendet.",
    "equaltocaseinsensitivemsg": "Bitte denselben Wert wiederholen.",
    "distanceunitmiles": "Meilen",
    "distanceunitkilometers": "Kilometer",
    "distanceperyearlabel": " pro Jahr",
    "hours": "Stunden",
    "priceinterval3": "(Zahlung alle 3 Monate)",
    "priceinterval12": "(j\u00e4hrliche Zahlung)",
    "priceinterval36": "(Zahlung alle 36 Monate)",
    "enterprise": "Firma",
    "enthintbuymore": "Ab 2 Au\u00dfendienstmitarbeiter-Lizenzen:",
    "enthintusermgmt": "Zentrale Benutzerverwaltung",
    "enthintrights": "Rechteverwaltung",
    "enthintorgsettings": "Firmenweite Einstellungen",
    "enthintapi": "Datenimport und Export via API",
    "enthintodata": "Datenanalyse via Excel und OData",
    "enthintadmins": "Kostenlose Administratoren-Zug\u00e4nge",
    "shopbuysub": "um {invoiceamountinclvat} alle {billinginterval} Monate bis K\u00fcndigung",
    "shopvatsub": "Der Betrag enth\u00e4lt {vatrate}% MwSt ({vatamount}).<br\/>Diese wird auf der Rechnung separat ausgewiesen.",
    "shopprice": "Preis",
    "shoppriceincurrency": "Preis in {currency}",
    "shopcurrencysub": "Alle Preise in {currency}",
    "shopvatnotapplicable": "{vatamount} MwSt. ({vatrate}%) wird verrechnet.",
    "shopordersumvatsub": "{totalincl} inkl. {vatrate}% MwSt",
    "shopmindatevalidate": "Datum muss ab {2} sein.",
    "enthintbuyevenmore": "Ab 10 Au\u00dfendienstmitarbeiter-Lizenzen:",
    "enthintusergroups": "Benutzergruppen",
    "etrackerstatus": "Status:",
    "etrackeractive": "etracker ist aktiviert.",
    "etrackerinactive": "etracker ist deaktiviert.",
    "etrackeroptin": "etracker aktivieren",
    "etrackeroptout": "etracker deaktivieren",
    "brPhoneErrorMessage": "Bitte geben Sie eine g\u00fcltige Telefonnummer an (10 oder mehr Zahlen)",
    "integererror": "Bitte geben Sie nur ganze Zahlen an",
    "initvatnrlabel": "UID\/VAT Nr.",
    "ptSimpleForm_date": "Bitte geben Sie ein g\u00fcltiges Datum an",
    "ptSimpleForm_mindate": "Datum muss ab {calculatedMinDate} sein",
    "ptSimpleForm_noWeekends": "Bitte nur Arbeitstage ausw\u00e4hlen",
    "ibanErrorMessage": "Bitte geben Sie eine g\u00fcltige IBAN an",
    "persontooltip": "Als Personen z\u00e4hlen Au\u00dfendienstmitarbeiter, f\u00fcr die Besuchspl\u00e4ne berechnet oder Gebiete optimiert werden, und Innen&shy;dienst&shy;mitarbeiter, welche die Software nutzen."
};
